/*
  * @Author: zql
  * @Date: 2025/1/10 17:41
*/

import router,{notFindRoutes,constantRoutes} from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getIsLogin,removeIsLogin,getToken} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import  matomo from '@/utils/matomo'
import _ from 'lodash'

NProgress.configure({showSpinner: false});

// '/login','/bind',
const whiteList = ['/auc', '/test']; // no redirect whitelist

router.beforeEach( async (to, from, next) => {
    NProgress.start();
    const title = getPageTitle(to.meta.title);
    document.title = title;
    const hasUserId = store.getters.user_id;
    if (whiteList.indexOf(to.path) !== -1) {
        next()
    }else if(from.query.sub_uid&&!to.query.sub_uid){
        if(to.path===from.path){
            to.query.t= new Date().getTime();
        }
        router.push({
            name:to.name,
            query:Object.assign({},to.query,{sub_uid:from.query.sub_uid}),
            params:to.params
        });
    }else if(to.query.sso_authorize_code){
        /* 没有token*/
        let sso_authorize_code = to.query.sso_authorize_code;
        // 在auc页面登录成功后，会跳回原页面，携带sso参数
        let res_sso = '';
        if(Array.isArray(sso_authorize_code) && sso_authorize_code.length>0) {
            res_sso = sso_authorize_code[sso_authorize_code.length-1];
        }else{
            res_sso = sso_authorize_code;
        };
          // 用最新的sso请求AUC
        const {auc} = await store.dispatch('user/getAUC',{
            sso_authorize_code:res_sso,
            // to_path:window.location.pathname,
        });
        next({
            ...to,
            query: _.omit(to.query, ['sso_authorize_code']) 
        })
    }else if (!hasUserId){
        const routeExists = router.getRoutes();
        // 获取info信息
        const {navigation,role_id} = await store.dispatch('user/getUserInfo');
        // 生成过滤后的路由
        const accessRoutes = await store.dispatch('permission/generateRoutes', navigation);
        accessRoutes.concat(notFindRoutes).forEach(item=>{
            if(!routeExists.some(route => route.path === item.path)){
                router.addRoute(item);
            }
        });
        const { team_name, name, position } = store.state.user;
        matomo.setUserId(`${name}_${team_name}_${position}`)
        matomo.setCustomVariable(1 ,'部门', team_name)
        matomo.setCustomVariable(2 ,'岗位', position)
        next({...to, replace: true})
    }else {
        next()
    }
});

router.afterEach((to, form) => {
    matomo.setCustomUrl(`${to.fullPath}`)
    matomo.trackPageView(`${ _.map(to.matched,(v)=>v.meta.title).join(' -> ')}`)
    NProgress.done()
});




